import React from "react";
import "./App.scss";
import Header from "./components/Header/Header";

import { Route, Routes } from "react-router-dom";
import Homepage2 from "./screen/Homepage2/Homepage2";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Homepage2 />} />
        {/* <Route path="/contact" element={<Contact />} />
        <Route path="/project" element={<Project />} /> */}
      </Routes>
    </>
  );
}

export default App;
